const { Core, Events } = Global;
customElements.define('collection-pagination', class extends Core {
    render() {
        this.sub(Events.COLLECTION_UPDATED, ({ doc }) => this.updateContentFrom(doc));
        this.$({ click: this._handleClick });
    }
    _handleClick(event) {
        const link = event.target.closest('[data-collection-page-link]');
        if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        this.pub(Events.COLLECTION_CHANGE, { url: link.href, src: 'pagination' });
    }
});
